<div class="card">
    <div class="card-body" [ngClass]="{'e-bigger': enableAdaptiveUI}">
        <ejs-grid #grid [dataSource]='data' [query]='query' [editSettings]="editSettings" [toolbar]="toolbar"
            [enableAdaptiveUI]="isMobileView" [rowRenderingMode]="enableAdaptiveUI ? 'Vertical' : 'Horizontal'"
            [columns]='columns' (actionBegin)='actionBegin($event)' (actionComplete)='actionComplete($event)'>
            <ng-template #editSettingsTemplate let-data>
                <div [formGroup]="formData">
                    <div class="row">
                        <div class="form-group col-lg-12 col-sm-12">
                            <ejs-autocomplete id='UserId' [dataSource]='userData' formControlName="UserId"
                                [allowCustom]="false" name="UserId" [query]="userQuery"
                                [fields]='{text:"FirstName", value:"Id"}' placeholder='User'
                                (filtering)="onFiltering($event, 'u')" floatLabelType="Always"
                                cssClass='{{ f.UserId.invalid && submitClicked ? "e-error" : ""}}'></ejs-autocomplete>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-12 ">
                            <input class="form-check-input ms-5 mt-4" formControlName="ReadOnly" name="ReadOnly"
                                type="checkbox" id="ReadOnly" value="f.ReadOnly">
                            <label class="form-check-label ms-2 mt-3" for="ReadOnly">
                                Read Only
                            </label>
                        </div>
                    </div>
                </div>
            </ng-template>
        </ejs-grid>
    </div>
</div>